var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThaiFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1998 4.80078C22.4998 2.30078 18.9498 0.800781 14.9998 0.800781C11.0498 0.800781 7.4998 2.30078 4.7998 4.80078H25.1998Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 26.8008C7.4998 29.3008 11.0498 30.8008 14.9998 30.8008C18.9498 30.8008 22.4998 29.3008 25.1998 26.8008H4.7998Z",
    fill: "#ED4C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.8008C0 17.9508 0.45 19.9508 1.25 21.8008H28.75C29.55 19.9508 30 17.9508 30 15.8008C30 13.6508 29.55 11.6508 28.75 9.80078H1.25C0.45 11.6508 0 13.6508 0 15.8008Z",
    fill: "#2A5F9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8002 26.8008H25.1502C26.6502 25.4008 27.9002 23.7008 28.7002 21.8008H1.2002C2.1002 23.7008 3.3002 25.4008 4.8002 26.8008Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 4.80078H4.8C3.3 6.20078 2.05 7.90078 1.25 9.80078H28.75C27.9 7.90078 26.7 6.20078 25.2 4.80078Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThaiFlag);
export default __webpack_public_path__ + "static/media/thai-flag.8040ba5a6352987237b8d76d9ac686c2.svg";
export { ForwardRef as ReactComponent };